module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/writable-browser.js
// module id = 250
// module chunks = 0 1